import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { SnackType } from '@/interfaces/snack'
import { ApolloResponse } from '@/interfaces/apollo'
import { ReducedUser } from '@/modules/User/interfaces/user'
import { showErrors, showNotification } from '@/utils/snack'

import PolicyForm from '@/modules/Policy/components/PolicyForm.vue'
import EndorsementForm from '@/modules/Policy/components/EndorsementForm.vue'
import { deletePolicyById } from '@/modules/Policy/gql/policy.gql'
import { getAllUsers } from '@/modules/User/gql/user.gql'

@Component({
  components: {
    AppDialog,
    PolicyForm,
    EndorsementForm
  }
})
export default class PolicyDialog extends Vue {
  targetPolicy: Policy | null = null
  targetQuote: Quote | null = null

  policyInfoDialog = {
    actionType: 'new',
    title: 'New Policy',
    highlightTitle: '',
    show: false,
    step: 0,
    disable: false
  }

  endorsementDialog = {
    title: 'Create Endorsement For Policy',
    show: false,
    step: 0,
    disable: false
  }

  deletePolicyDialog = {
    show: false,
    title: 'Delete Policy',
    text: ''
  }

  selectRecordTypeDialog = false

  recordTypeIndex = 0

  userList: ReducedUser[] = []
  get usersOptions () {
    return this.userList.map(user => user.username)
  }

  showPolicyEditDialog (step = 0, targetPolicy?: Policy) {
    let actionType = 'new'
    let title = 'New Policy'
    let highlightTitle = this.policyInfoDialog.highlightTitle
    if (targetPolicy) {
      this.targetPolicy = targetPolicy
      actionType = 'edit'
      title = 'Edit Policy'
      highlightTitle = targetPolicy.recordType.name || ''
    }
    this.policyInfoDialog = {
      actionType,
      show: true,
      title,
      step,
      disable: false,
      highlightTitle
    }
  }

  showPolicyEndorsementDialog () {
    this.endorsementDialog.show = true
  }

  newPolicyByQuote (e: Event, targetQuote: Quote) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Policy'
    let highlightTitle = targetQuote.recordType.name
    this.targetQuote = targetQuote
    this.policyInfoDialog = {
      actionType,
      show: true,
      title,
      step: 0,
      disable: false,
      highlightTitle
    }
  }

  hidePolicyEditDialog () {
    this.targetPolicy = null
    this.targetQuote = null
    this.policyInfoDialog = {
      actionType: 'new',
      show: false,
      title: 'New Policy',
      step: 0,
      highlightTitle: '',
      disable: false
    }
  }

  hideEndorsementEditDialog () {
    this.endorsementDialog.show = false
    this.endorsementDialog.step = 0
  }

  async deletePolicy (e: Event, policy: Policy) {
    e.preventDefault()
    e.stopPropagation()
    this.targetPolicy = policy
    this.deletePolicyDialog.show = true
  }

  async deletePolicyPost () {
    if (!this.targetPolicy) {
      return
    }
    const { id } = this.targetPolicy
    this.deletePolicyDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deletePolicyById,
        variables: {
          policyId: Number(id)
        }
      })

      const res = result.data.deletePolicyById
      if (res) {
        showNotification({
          msg: 'Delete Policy successfully',
          type: SnackType.Success
        })
        this.targetPolicy = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async getUsers () {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAllUsers
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.userList = result.data.getAllUsers
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  hidePolicyDialog () {
    this.targetQuote = null
    this.policyInfoDialog = {
      actionType: 'new',
      title: 'New Policy',
      highlightTitle: '',
      show: false,
      step: 0,
      disable: false
    }
  }
}
